import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import HorizontalDivider from "src/components/HorizontalDivider/HorizontalDivider";
import VerticalDivider from "src/components/VerticalDivider/VerticalDivider";
import { isRtl } from "src/utils/helpers";

const InvoiceNotes = () => {
  const { language } = useSelector((state: any) => state.lookup);

  const { t } = useTranslation(["common", "registration", "invoice"]);
  return (
    <div>
      <section
        className="invoice-body invoice-important-notes mt-1"
        style={{ direction: "ltr" }}
      >
        <div
          className="invoice-body__title py-1 d-flex justify-content-between align-items-center"
          style={{ textAlign: isRtl(language) ? "right" : "left" }}
        >
          <span>Important Notes/Payment Terms</span>
          <span> ملاحظات هامة / طريقة الدفع</span>
        </div>
        <div className="invoice-header__details__info d-flex flex-column">
          <div className="invoice-header__details__info__row d-flex justify-content-between ">
            <div className="invoice-header__details__info__row__item d-flex align-items-start justify-content-between  pt-1 w-50">
              <p className="text-start  m-0">
                The fees payable are determined by the number of buildings you
                select, and the number of fire and life safety systems added to
                your account for those buildings, as specified in the
                maintenance contracts you have with the buildings and/or
                establishments.
              </p>
            </div>
            <VerticalDivider />
            <div className="invoice-header__details__info__row__item d-flex align-items-start justify-content-center pt-1 w-50">
              <p className="text-end arabic-text  m-0">
                يتم تحديد الرسوم المستحقة بناءً على عدد المباني التي تُضاف إلى
                حسابك وعدد أنظمة الوقاية والسلامة من الحرائق المرتبطة بتلك
                المباني، وذلك وفقًا لما هو مذكور في عقود الصيانة المبرمة مع
                المباني و/أو المنشآت.
              </p>
            </div>
          </div>
          <HorizontalDivider />
          <div className="invoice-header__details__info__row d-flex justify-content-between  ">
            <div className="invoice-header__details__info__row__item d-flex align-items-start justify-content-between  pt-1 w-50">
              <p className="text-start  m-0">
                Payment must be made before the due date through the online
                portal to ensure service continuity. Any additional fees charged
                by your bank or for card transactions are not included in this
                amount and will be charged separately during the online payment
                process
              </p>
            </div>
            <VerticalDivider />
            <div className="invoice-header__details__info__row__item d-flex align-items-start justify-content-center pt-1 w-50">
              <p className="text-end arabic-text  m-0">
                يجب سداد  الرسوم  قبل تاريخ الاستحقاق من خلال البوابة
                الإلكترونية لضمان استمرارية الخدمة. لا يتم احتساب أي رسوم إضافية
                يفرضها البنك الذي تتعامل معه أو على معاملات البطاقة ضمن هذا
                المبلغ، وسيتم احتسابها بشكل منفصل أثناء عملية الدفع.
              </p>
            </div>
          </div>
          <HorizontalDivider />
          <div className="invoice-header__details__info__row d-flex justify-content-between  ">
            <div className="invoice-header__details__info__row__item d-flex align-items-start justify-content-between  pt-1 w-50">
              <p className="text-start  m-0">
                Ensure all details are accurate before making any payment.
                Refunds are not applicable for completed payments, even if a
                building/establishment is unassigned or a fire and life safety
                (FLS) system is removed after the payment has been processed
              </p>
            </div>
            <VerticalDivider />
            <div className="invoice-header__details__info__row__item d-flex align-items-start justify-content-center pt-1 w-50">
              <p className="text-end arabic-text  m-0">
                يجب التأكد من دقة جميع التفاصيل قبل الدفع حيث انه لا يمكن
                استرداد أي مبلغ مدفوع، حتى فى حالة إزالة المبنى او المنشأة أو
                نظام  الوقاية والسلامة  (FLS) من حسابك بعد إتمام الدفع.
              </p>
            </div>
          </div>
          <HorizontalDivider />
          <div className="invoice-header__details__info__row d-flex justify-content-between  ">
            <div className="invoice-header__details__info__row__item d-flex align-items-start justify-content-between  pt-1 w-50">
              <p className="text-start  m-0">
                This is a system-generated form and does not require a
                signature. For any discrepancies in the details mentioned above,
                please make the necessary corrections through the online portal
                or report them to Hassantuk for further assistance.
              </p>
            </div>
            <VerticalDivider />
            <div className="invoice-header__details__info__row__item d-flex align-items-start justify-content-center pt-1 w-50">
              <p className="text-end arabic-text m-0">
                تم إصدار هذه الفاتورة بشكل تلقائي من النظام ولا يجب توقيعها. في
                حال وجود أي تعديل في التفاصيل المذكورة أعلاه يرجى التعديل من
                خلال المنصة الإلكترونية أو التواصل مع حصنتك للمباني لإجراء
                اللازم.
              </p>
            </div>
          </div>
          <HorizontalDivider />
        </div>
      </section>
      <section className="invoice-footer d-flex py-1 px-2 justify-content-between">
        <div className=" d-flex gap-2">
          <span> {t("invoiceDetails.freeNumber1")}</span>
          <span>800333363</span>
        </div>
        <div className=" d-flex gap-2">
          <span> {t("invoiceDetails.contactUsOnEmail")}</span>
          <span>contactus@hassantuk.com</span>
        </div>
        <div className="d-flex gap-2">
          <span> {t("invoiceDetails.forMoreInformation")}</span>
          <span>Bmc.hassantuk.com</span>
        </div>
      </section>
    </div>
  );
};

export default InvoiceNotes;
